import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, KeyValues3, LocalService, LookupType, Paging, StatusWithId, Wrappers10, Wrapper10 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private controllerName = service_controllers_methods.lookup.controller;
  private methods = service_controllers_methods.lookup.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getLookup(strId: string): Observable<Wrapper10> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLookup, body);
  }

  public saveLookup(wrapper: Wrapper10): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveLookup, body);
  }

  public getLookups(lookupType: LookupType, paging?: Paging, isActive: boolean = true, searchKeyInitial: string = ''): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: lookupType.toString(), v2: isActive ? '1' : '0', v3: searchKeyInitial } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLookups, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public deleteLookups(lookupType: LookupType, isActive: boolean, paging?: Paging): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: { v1: lookupType.toString(), v2: isActive ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteLookups, body, true, false, true);
  }

  public deleteLookup(id: string, lookupType: LookupType, isActive: boolean): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: lookupType.toString(), v2: isActive ? '1' : '0', v3: id } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteLookup, body);
  }
}
